<template>
  <section v-if="transaction" class="d-flex flex-column">
    <v-card
      class="bill-service-card"
      style="background-color: transparent"
      :style="{
        'border-left': `8px solid ${
          transaction.status === 5
            ? '#FF5252'
            : !!transaction.have_an_proof_of_payment
            ? '#1976D2'
            : '#4CAF50'
        }`,
      }"
    >
      <div class="bill-service-card__row">
        <h6
          :style="{
            lineHeight: $vuetify.breakpoint.mdAndUp ? '1.4' : '1.3',
          }"
          class="text-subtitle-1 text-md-h6 font-weight-medium mb-0 bill-service-card__title"
        >
          {{ transaction.service }}
          <span v-if="transaction.status === 5">(excluido)</span>
        </h6>

        <h6
          class="text-subtitle-1 text-md-h6 grey--text text--darken-1 font-weight-medium mb-0 bill-service-card__amount"
        >
          $ {{ transaction.amount }}
        </h6>

        <span class="grey--text text--darken-1 bill-service-card__pedido">
          Pedido {{ transaction.request_id || transaction.request }}
        </span>

        <span
          v-if="transaction.payment_day"
          class="grey--text text--darken-1 bill-service-card__payment-day"
        >
          Cobrado el {{ transaction.payment_day | formatDateShort }}
        </span>

        <div
          v-if="transaction.status === 5"
          class="bill-service-card__actions d-flex justify-end"
        >
          <v-hover v-slot="{ hover }">
            <v-btn
              text
              elevation="0"
              class="px-0 text-none"
              :color="hover ? 'blue darken-2' : ''"
              style="opacity: 0.6; display: flex; justify-content: end"
              @click="showDetails()"
            >
              <v-icon size="20"> mdi-information-outline </v-icon>
              <span class="hidden-sm-and-down ml-1">Ver motivo</span>
            </v-btn>
          </v-hover>
        </div>
      </div>

      <v-dialog v-model="rejectDetails" v-if="rejectDetails" max-width="660">
        <v-card>
          <v-card-title class="pt-6 px-6 pb-0 d-flex align-start">
            <v-icon size="48" class="mr-4 revision-icon" color="red accent-2"
              >mdi-alert-outline</v-icon
            >
            <span class="font-weight-bold hidden-sm-and-down"
              >Servicio excluido</span
            >
            <v-spacer></v-spacer>
            <v-icon class="revision-icon" @click="rejectDetails = false"
              >clear</v-icon
            >
            <span
              class="font-weight-bold hidden-sm-and-up pt-4 pb-2"
              style="width: 100%"
              >Servicio excluido</span
            >
          </v-card-title>
          <v-card-text class="revision-text-container">
            <span style="opacity: 0.9">
              <strong>Motivo:</strong>
              {{ transaction.comment || transaction.reject_reason }}
            </span>
            <span>
              Si tenés dudas podés comunicarte con administración mediante
              WhatsApp al +54 9 351 862-2725.
            </span>
          </v-card-text>
          <v-card-actions class="pa-6 pt-8">
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="blue darken-2 white--text wid"
              @click="rejectDetails = false"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </section>
</template>

<script>
export default {
  name: "BillServiceCard",
  props: {
    transaction: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    rejectDetails: false,
  }),
  methods: {
    showDetails() {
      this.rejectDetails = true;
    },
  },
};
</script>

<style scoped>
.bill-service-card__row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  column-gap: 0.75rem;
  row-gap: 0.15rem;
  width: 100%;
  min-width: 0;
  padding: 12px 12px 12px 8px;
  align-items: start;
}

.bill-service-card__title {
  grid-column: 1;
  grid-row: 1;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.bill-service-card__amount {
  grid-column: 2;
  grid-row: 1;
  white-space: nowrap;
  text-align: right;
}

.bill-service-card__pedido {
  grid-column: 1;
  grid-row: 2;
  align-self: center;
}

.bill-service-card__payment-day {
  grid-column: 2;
  grid-row: 2;
  text-align: right;
  white-space: nowrap;
}

.bill-service-card__actions {
  grid-column: 2;
  grid-row: 2;
  align-self: center;
  justify-self: end;
}

.revision-text-container {
  opacity: 0.9;
  color: black !important;
  padding: 0 85px !important;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

::v-deep .wid {
  width: auto;
}

@media (min-width: 960px) {
  .bill-service-card__row {
    padding: 16px 32px 16px 16px;
  }
}

@media (max-width: 959px) {
  .bill-service-card__amount {
    align-self: center;
  }
}

@media (max-width: 600px) {
  ::v-deep .wid {
    width: 100% !important;
  }
  .revision-text-container {
    padding: 0 24px !important;
  }

  .revision-icon {
    font-size: 24px !important;
  }
}
</style>
